import cn from 'classnames';
import { ELEMENT_SIZE, InputField, Panel, Radio } from 'ht-styleguide';
import { TRadioSelector } from '@scenes/HomeHub/homehub.types';
import { COLUMN_WIDTHS } from '../constants';
import styles from '../selectors.module.scss';

const RadioSelector = ({ onInputChange, onIconClose, showInput, gridColumn, inputRef, classes, ...props }: TRadioSelector) => {
  const isOtherOption = props.selected && showInput;
  const radioStyles = cn(styles.commonRadioContainer, classes, {
    [styles.grid1]: gridColumn === COLUMN_WIDTHS.ONE_COLUMN,
    [styles.grid2]: gridColumn === COLUMN_WIDTHS.TWO_COLUMNS,
    [styles.grid3]: gridColumn === COLUMN_WIDTHS.THREE_COLUMNS,
    [styles.inputPanel]: isOtherOption,
    [styles.radioPanel]: !isOtherOption,
  });

  return (
    <Panel className={radioStyles} noShadow largeBorderRadius key={props.value}>
      {!isOtherOption && <Radio key={`${props.label}-${props.value}`} elementSize={ELEMENT_SIZE.S} wrapperClass={styles.radio} {...props} />}
      {isOtherOption && (
        <InputField
          key={`${props.label}-${props.value}`}
          elementSize={ELEMENT_SIZE.L}
          ref={inputRef}
          onChange={onInputChange}
          iconName="close"
          iconOnClick={onIconClose}
          iconClass={styles.closeInputIcon}
          placeholder="Please specify"
        />
      )}
    </Panel>
  );
};

export default RadioSelector;
